// Mobile menu toggle functionality
document.addEventListener('DOMContentLoaded', function() {
    const menuButton = document.querySelectorAll('.js-mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');
    
    if (menuButton && mobileMenu) {
        let isMenuOpen = false;

        // Store original button text for each button
        const originalButtonText = [];
        menuButton.forEach((btn) => {
            originalButtonText.push(btn.textContent.trim());
        });

        // Toggle menu function
        function toggleMenu() {
            isMenuOpen = !isMenuOpen;

            if (isMenuOpen) {
                // Add class to body
                document.body.classList.add('has-menu-open');

                // Show background first
                mobileMenu.classList.remove('opacity-0', 'pointer-events-none');
                mobileMenu.classList.add('opacity-100', 'pointer-events-auto');
                menuButton.forEach((btn, index) => {
                    btn.setAttribute('aria-expanded', 'true');
                    // Change button text to close label
                    const closeLabel = btn.getAttribute('data-label-close');
                    if (closeLabel) {
                        btn.textContent = closeLabel;
                    }
                });
                
                // Enable wheel scrolling on mobile menu
                const menuScroller = mobileMenu.querySelector('.w-full.h-full.overflow-y-auto');
                if (menuScroller) {
                    menuScroller.addEventListener('wheel', function(e) {
                        e.stopPropagation();
                        // Allow natural scrolling on this element
                    });
                }
                
                // Animate menu items with delay
                const menuItems = document.querySelectorAll('[data-menu-item]');
                menuItems.forEach((item, index) => {
                    setTimeout(() => {
                        item.classList.remove('opacity-0', 'translate-y-8');
                        item.classList.add('opacity-100', 'translate-y-0');
                    }, (index * 200)); // 150ms base delay + 80ms per item
                });
            } else {
                // Remove class from body
                document.body.classList.remove('has-menu-open');

                // Hide menu items instantly
                const menuItems = document.querySelectorAll('[data-menu-item]');
                menuItems.forEach((item) => {
                    item.classList.remove('opacity-100', 'translate-y-0');
                    item.classList.add('opacity-0', 'translate-y-8');
                });

                // Hide background
                mobileMenu.classList.remove('opacity-100', 'pointer-events-auto');
                mobileMenu.classList.add('opacity-0', 'pointer-events-none');
                menuButton.forEach((btn, index) => {
                    btn.setAttribute('aria-expanded', 'false');
                    // Restore original button text
                    btn.textContent = originalButtonText[index];
                });
            }
        }
        
        // Add click event to menu button
        menuButton.forEach((btn, index) => {
            btn.addEventListener('click', toggleMenu);
        });
        
        // Close menu when clicking on navigation links
        const mobileNavLinks = mobileMenu.querySelectorAll('a');
        mobileNavLinks.forEach(link => {
            link.addEventListener('click', () => {
                if (isMenuOpen) {
                    toggleMenu();
                }
            });
        });
        
        // Close menu when clicking outside
        /*
        document.addEventListener('click', function(event) {
            if (isMenuOpen && !menuButton.contains(event.target) && !mobileMenu.contains(event.target)) {
                toggleMenu();
            }
        });
        */
        
        // Close menu on escape key
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && isMenuOpen) {
                toggleMenu();
            }
        });
    }
});